import useToastStore from '~/stores/toast'

const defaultOptions = {
  bottom: true
}

let toastStore: any

export const toast = {
  toast(message: string, options?: any) {
    const toastOptions = {
      ...defaultOptions,
      message,
      ...options
    }

    toastStore.toast(toastOptions)
  },
  success(message: string, options?: any) {
    const toastOptions = {
      ...defaultOptions,
      color: 'success',
      icon: 'mdi-check',
      message,
      ...options
    }

    toastStore.toast(toastOptions)
  },
  error(message: string, options?: any) {
    const toastOptions = {
      ...defaultOptions,
      color: 'error',
      icon: 'mdi-alert-circle-outline',
      message,
      ...options
    }

    toastStore.toast(toastOptions)
  },
  warning(message: string, options?: any) {
    const toastOptions = {
      ...defaultOptions,
      color: 'warn',
      icon: 'mdi-alert',
      message,
      ...options
    }

    toastStore.toast(toastOptions)
  }
}

export default defineNuxtPlugin(() => {
  toastStore = useToastStore()
  return {
    provide: { toast }
  }
})
